export default {
    READ: 1,
    UNREAD: 2
};
